import { Injectable } from '@angular/core';
import {MembershipModel} from "./membership-model";
import {Observable} from "rxjs";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {map} from "rxjs/operators";
import {collection, getCountFromServer, getFirestore, query} from "firebase/firestore";

@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  private collectionName = 'memberShip';

  constructor(private firestore: AngularFirestore) {}

  // Add a new membership
  addMembership(membership: MembershipModel): Promise<any> {
    return this.firestore.collection(this.collectionName).add(membership);
  }

  // Get all memberships
  getAllMemberships(): Observable<MembershipModel[]> {
    return this.firestore.collection<MembershipModel>(this.collectionName).valueChanges({idField:'id'});
  }

  // Get membership by ID
  getMembershipById(id: string): Observable<MembershipModel | undefined> {
    return this.firestore.collection<MembershipModel>(this.collectionName).doc(id).valueChanges();
  }

  // Update membership
  updateMembership(id: string, membership: Partial<MembershipModel>): Promise<void> {
    membership.updatedAt = new Date();
    return this.firestore.collection(this.collectionName).doc(id).update(membership);
  }

  // Delete membership
  deleteMembership(id: string): Promise<void> {
    return this.firestore.collection(this.collectionName).doc(id).delete();
  }
  getMembershipCount(): Observable<number> {
    return this.firestore.collection<MembershipModel>(this.collectionName).valueChanges().pipe(
      map(memberships => memberships.length)
    );
  }

  //* Count-only variant using Firestore count() aggregation — avoids downloading full documents just to read .length
  getMembershipCountFromServer(): Promise<number> {
    const q = query(collection(getFirestore(), this.collectionName))
    return getCountFromServer(q).then(snap => snap.data().count)
  }
}
